import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

// 白カード（セクション容器）。淡い罫線 + 控えめな影。3アプリ共通。
export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div className={cn("rounded-lg border border-line bg-paper shadow-card", className)}>
      {children}
    </div>
  );
}
